import React from 'react'

function MapaUbicacion() {
  return (
        <div className='w-full h-48 border border-Negro bg-GrisClaro '>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d222.52129069147807!2d-65.17965026182529!3d-26.829115461185896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94225fdbb3a27827%3A0xeec824490972b11d!2sAGRO%20H!5e0!3m2!1ses-419!2sar!4v1724250439475!5m2!1ses-419!2sar"
             className="w-full h-full border-0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">              
              </iframe>
        </div>
  )
}

export default MapaUbicacion